import { useSelector } from 'react-redux';
import ProductModifiers from './ProductModifiers';
import AddToCart from './AddToCart';
import SpecialInstructions from './SpecialInstructions';
import { shouldHideOrderCustomization } from '../../../scripts/helpers';

const ProductContainer = ({product}) => {
    const mod = useSelector(state => state.productDetails.data)
    const hideOrderCustomization = shouldHideOrderCustomization(product)

    return <>
        {mod && <>
            <ProductModifiers modifiers={mod} product={product}/>
            {!hideOrderCustomization && <SpecialInstructions product={product}/>}
            <AddToCart />
        </>}  
    </>
}

export default ProductContainer